{
  "settings": "Поставки",
  "yourDigitalAssistant": "Вашиот дигитален асистент",
  "getStarted": "Почни",
  "login": "Логирај Се",
  "loggingIn": "Најавување ...",
  "darkMode": "Темен режим",
  "clearHistory": "Чиста историја",
  "historyCleared": "Историјата е исчистена",
  "changeLanguage": "Јазик",
  "termsAndConditions": "Услови на употреба",
  "messagePlaceholder": "Внесете ја вашата порака тука ...",
  "messagePlaceholderDisabled": "Пишувањето е оневозможено ...",
  "feedbackTitle": "Оценете го вашето искуство",
  "feedbackPlaceholder": "Кажете ни за тоа (по избор)",
  "feedbackSend": "Испрати",
  "feedbackClose": "Затвори",
  "sessionExpired": "Вашата сесија истече поради неактивност.",
  "startNewSession": "Започнете нова сесија",
  "apiError": "Упс! Нешто тргна наопаку. Работиме на тоа да го решиме што побрзо.",
  "apiErrorOffline": "Не сте поврзани на Интернет.",
  "tryAgain": "Обиди се повторно",
  "startOver": "Започнете одново",
  "chatEnded": "Разговорот заврши",
  "chatEndedThankYou": "Ви благодариме што разговаравте со нас!",
  "closeChat": "Затвори",
  "startNewChat": "Разговор повторно",
  "humanTakeoverStarted": "Сега сте префрлени на услуги на клиенти ...",
  "humanTakeoverQueued": "Чекам да се поврзам со агент",
  "humanTakeoverAnAgent": "Агент",
  "humanTakeoverAgentEntered": "влезе во разговорот",
  "humanTakeoverAgentLogout": "го напушти разговорот",
  "humanTakeoverTransfer": "Вие сте префрлени на нов агент",
  "humanTakeoverEnded": "Сега разговарате со вашиот дигитален асистент",
  "version": "Верзија",
  "formIntroText": "Ве молиме, пополнете го следниот формулар за да започнете разговор со нас.",
  "formFirstName": "Име",
  "formLastName": "Презиме",
  "formName": "Име",
  "formEmail": "Е-пошта",
  "formWrongEmail": "Ве молиме наведете важечка адреса за е-пошта.",
  "formPhone": "Телефон",
  "formShipmentId": "ИД на пратка",
  "formQuestion": "Твоето прашање",
  "formAccountNumber": "Број на сметка (за деловни клиенти)",
  "formAddress": "адреса",
  "formPostcode": "поштенски код",
  "formCity": "град",
  "formCountry": "земја",
  "formSubmitButton": "Започнете разговор",
  "formEmptyFieldError": "Не е дозволено да биде празен.",
  "formPhoneNumberValidationError": "Не е валиден телефонски број.",
  "formInputIsBiggerThan50": "Мора да има најмногу 50 карактери.",
  "formInputIsBiggerThan100": "Мора да има најмногу 100 карактери.",
  "formInputIsBiggerThan2000": "Мора да има најмногу 2000 карактери.",
  "widgetEventOnline": "Порака за ДА: Корисникот е повторно на Интернет.",
  "widgetEventHidden": "Порака за ДА: Виџетот е скриен.",
  "widgetEventVisible": "Порака за ДА: Виџетот е видлив.",
  "widgetEventVisibleMinimized": "Порака за ДА: Виџетот е видлив, но минимизиран.",
  "widgetEventMinimized": "DA порака: Виџетот е минимизиран.",
  "widgetEventMaximized": "DA порака: Виџетот е максимизиран.",
  "widgetEventSessionExpired": "Порака за ДА: Сесијата на виџетот истече.",
  "widgetEventHangupHuman": "ДА порака: Корисникот ја завршува сесијата за преземање луѓе.",
  "widgetEventUserTyping": "DA порака: Корисникот пишува.",
  "fileTooLarge": "Обидувате да прикачите премногу големи датотеки.",
  "tooManyDiles": "Обидувате да прикачите премногу датотеки.",
  "fileInvalidType": "Обидувате да прикачите невалидни типови на датотеки.",
  "attachmentsDropHere": "Фрли тука за да испратите или",
  "attachmentsBrowse": "Прелистајте датотеки",
  "attachmentsExtenstionQuantity": "pdf или слики (до 10 датотеки)",
  "attachmentsSize": "до 30 MB",
  "attachmentsFailedUploading": "Поставувањето не успеа",
  "attachmentsUploading": "Се поставува ...",
  "minimizeExpandText": "Разговор во живо со нас сега!",
  "popupWidgetNotificationMessage": "Добивте нова порака!",
  "tabWidgetNotificationMessage": "Нова порака!",
  "datepickerSendButton": "Испрати"
}
